<template>
  <div>
    <div class="culturalhistory">
      <div class="bannerbg" @click="handlevideoAction()">
        <img
            src="~@/assets/images/mainindex/jingwai-banner@2x.jpg"
            class="bannerbg_pic"
        />
        <div>
          <div class="bannerbg_desc" >
            <div class="bannerbg_desc_title">境外交流</div>
            <div class="bannerbg_desc_entitle">OVERSEAS COMMUNICATION</div>
          </div>
        </div>
      </div>

      <div class="container_wrap">
        <div class="jingwai-title">
          <span class="jingwai-title-1">境外活动</span><span class="jingwai-title-2">Events</span>
        </div>
        <div class="zhou-wrap">
          <div>
            <img v-rblink="{ name: 'jingwaiZhou', query: { cate_id: 127 } }" src="~@/assets/images/mainindex/pic-zhou1.jpg" />
            <img v-rblink="{ name: 'jingwaiZhou', query: { cate_id: 124 } }" src="~@/assets/images/mainindex/pic-zhou2.jpg" />
            <img v-rblink="{ name: 'jingwaiZhou', query: { cate_id: 126 } }" src="~@/assets/images/mainindex/pic-zhou3.jpg" />
          </div>
          <div>
            <img v-rblink="{ name: 'jingwaiZhou', query: { cate_id: 125 } }" src="~@/assets/images/mainindex/pic-zhou4.jpg" />
            <img v-rblink="{ name: 'jingwaiZhou', query: { cate_id: 128 } }" src="~@/assets/images/mainindex/pic-zhou5.jpg" /> 
          </div>
        </div>

        <div class="jingwai-title">
          <span class="jingwai-title-1">活动新闻</span><span class="jingwai-title-2">News</span>
        </div>


    <!-- 新闻资讯 -->
    <div class="news_info container_wrap"> 
      <div class="news_info_content">
        <div class="news_info_left" v-for="(item, index) in row.news.slice(0, 1)"
             v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"
             :key="item.id">
          <img :src="item.pic_url" alt=""/>
          <div class="news_info_desc">
            <div class="news_info_desc_title">
              {{ item.title }}
            </div>
            <div class="news_info_desc_subtitle">
              {{ item.desc }}
            </div>
            <div class="news_info_desc_nums">
              <div class="news_info_desc_nums_date"> {{ item.create_time | formatDate }}</div>
              <div class="news_info_desc_nums_fire">{{ item.views_count }}</div>
            </div>
            <div class="news_info_desc_jump"></div>
          </div>
        </div>
        <div class="news_info_right">
          <div
              class="news_info_right_items"
              v-for="(item, index) in row.news.slice(1,6)"
              :key="item.id"
              v-rblink="{ name: 'CmsDetail', query: { id: item.id } }"
          >
            <div class="news_info_right_item">
              <div style="background:#0000006e;position: absolute;width:100%;height:100%;z-index: 10;"></div>
              <img :src="item.pic_url" alt=""/>
              <div class="news_info_right_item_date">{{ item.create_time | formatDate }}</div>
              <div class="news_info_right_item_title">
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="news_info_right_items" v-rblink="{ name: 'NewsList', query: { cate_id: 12 } }">
            <!-- <div class="news_info_right_item_last_count">{{ this.news_2.length }}<sup>+</sup></div> -->
            <div class="news_info_right_item_last_count">9999<sup>+</sup></div>
            <div class="news_info_right_item_last_more">
              更多精彩<i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="jingwai-title">
      <span class="jingwai-title-1">常见问题</span><span class="jingwai-title-2">FAQs</span>
    </div>

    <div class="faq-wrap">
      <div>
        <img v-rblink="{ name: 'CmsDetail', query: { id: 668 } }" src="~@/assets/images/mainindex/pic-faq1.png" />
        <img v-rblink="{ name: 'CmsDetail', query: { id: 669 } }" src="~@/assets/images/mainindex/pic-faq2.png" />
        <img v-rblink="{ name: 'CmsDetail', query: { id: 670 } }" src="~@/assets/images/mainindex/pic-faq3.png" />
        <img v-rblink="{ name: 'CmsDetail', query: { id: 671 } }" src="~@/assets/images/mainindex/pic-faq4.png" />
      </div> 
    </div>

  
 
      </div>
 

    </div>
  </div>
</template>
<script>
  import {formatDate} from "../../utils/date";
import SpecialTabs from "@/components/mainindex/SpecialTabs";
import ColumnTitle from "@/components/mainindex/ColumnTitle";

export default {
  name: "CulturalHistory",
  data() {
    return {
      videoAction: false,
      centerDialogVisible: false,
      tabList: [
        {name: "风采资讯", class: "tabs-item-active"},
        {name: "考级信息", class: ""},
        {name: "考级中心考级点", class: ""},
      ],

      cateList: [],
      personList: [],
      activeName: '',
      row: {
        swiper: [],
        notice: [],
        news: [],
        course: [],
      }

      // columnList: [
      //   {name: "百佳四好运动员", cate_id: 16},
      //   {name: "十佳教练", cate_id: 17},
      //   {name: "十佳导师", cate_id: 19},
      //   {name: "十佳考官", cate_id: 6},
      //   {name: "十佳培训师", cate_id: 6},
      //   {name: "十佳监督", cate_id: 6},
      //   {name: "十佳执行官", cate_id: 6},
      //   {name: "十佳俱乐部", cate_id: 6},
      //   {name: "先进推进个人", cate_id: 6},
      //   {name: "十佳赛区", cate_id: 6},
      //   {name: "十佳考级中心", cate_id: 6},
      // ],

      // activeIndex: 0,
    };
  },
  mounted() {
    document.title = "境外交流"
    this.getNewsList() 
  },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, " M-d ");
    },
  },
  components: {
    SpecialTabs, ColumnTitle
  },
  methods: {
  

    getNewsList(){
      const that = this;
      that.$api.get(
          "/api/cms/cmslist",
          {
            cate_id: 57,
          },
          (res) => {
            this.row.news = res.data.list; 
          },
      );
    },
 
    toDetail(id) {
      this.$router.push({path: "/cmsdetail", query: {id: id}});
    },

    onSelectType(item) {
      this.activeName = item.name
      this.getPersonList(item.id)
    },

    // 显示h5网页打开二维码
    onWhjDetail() {
      this.centerDialogVisible = true
    },

    //处理video点击事件
    handlevideoAction() {
      return
      this.videoAction = !this.videoAction;
      if (!this.videoAction && this.$refs.myVideo) {
        setTimeout(() => {
          this.$refs.myVideo.pause();
          this.$refs.myVideo.currentTime = 0;
        }, 600);
      }
    },

  },

};
</script>
<style lang="scss" scoped>

.container_wrap {
  width: 1200px;
  margin: 0 auto;

  .jingwai-title{
    margin-top: 50px;
    .jingwai-title-1{ 
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1F2329;
      line-height: 45px;
      margin-right:10px
    }
    .jingwai-title-2{ 
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #D7DDE5;
      line-height: 42px;
      letter-spacing: 5px;
    }
  }
  .zhou-wrap{
    div{
      display: flex;
      flex-wrap:wrap;
      margin:20px 0 ;
      justify-content:space-between;
    }
    img{
      cursor: pointer;
      height: 352px;
    }
  }

  .faq-wrap{
    div{
      display: flex;
      flex-wrap:wrap;
      margin:20px 0 ;
      justify-content:space-between;
    }
    img{
      cursor: pointer;
      height: 214px;
    }
  }

  .wenhuaji-img img {
    margin-right: 15px;
    border-radius: 5px;
    cursor: pointer;

    &:nth-child(3) {
      margin: 0;
    }
  }
}

.news_info {
  .title_and_subtitle {
    padding-bottom: 10px;
  }

  .news_info_content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* height: 848px; */

    .news_info_left {
      width: 480px;
      height: 340px;
      position: relative;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;

      img {
        /* width: 736px; */
        /* height: 848px; */
        object-fit: cover;
      }

      .news_info_desc {
        height: 160px;
        width: 100%;
        position: absolute;
        bottom: 0;
        background: linear-gradient(rgba(0, 0, 0, 0.49), rgba(0, 0, 0, 0.49));
        padding: 26px 40px 24px 20px;
        box-sizing: border-box;

        .news_info_desc_title {
          font-size: 20px;
          font-weight: 500;
          color: #ffffff;
          line-height: 28px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .news_info_desc_subtitle {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;

          height: 40px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.5);
          line-height: 20px;
          margin: 11px 0;
        }

        .news_info_desc_nums {
          height: 21px;
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          line-height: 21px;
          display: flex;
          flex-direction: row;

          .news_info_desc_nums_date {
            margin-right: 28px;
            position: relative;
            padding-left: 33px;

            &::before {
              content: "";
              display: block;
              width: 22px;
              height: 21px;
              left: 0px;
              position: absolute;
              background: url("~@/assets/images/mainindex/icon-calendar@2x.png") center center no-repeat;
              background-size: 100% 100%;
            }
          }

          .news_info_desc_nums_fire {
            position: relative;
            padding-left: 23px;

            &::before {
              content: "";
              display: block;
              width: 16px;
              height: 21px;
              left: 0px;
              position: absolute;
              background: url("~@/assets/images/mainindex/jianshen-huoyan-reqing-xihuan.png") center center no-repeat;
              background-size: 100% 100%;
            }
          }
        }

        .news_info_desc_jump {
          position: absolute;
          bottom: 21px;
          right: 40px;
          width: 43px;
          height: 43px;
          background: url("~@/assets/images/mainindex/icon-news-viewmore@2x.png") center center no-repeat;
          background-size: 100% 100%;

          &:hover {
            cursor: pointer;
            opacity: 0.8;
          }
        }
      }
    }

    .news_info_right {
      width: 700px;
      height: 340px;
      width: 700px;
    height: 340px; 
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap; 

      .news_info_right_items {
        display: inline-block;
        width: 220px;
        height: 160px;
        box-sizing: border-box;
        margin-bottom: 18px;
        border-radius: 3px;
        overflow: hidden;

        &:nth-child(3n + 1) {
          margin-right: 12px;
        }
        &:nth-child(3n + 2) {
          margin-right: 12px;
        }

        &:nth-last-child(2) {
          margin-bottom: 0;
          margin-right: 8px;
        }

        &:last-child {
          margin-bottom: 0;
          background: #3b8de3;
          position: relative;
          transition: all 1s;
          margin-left: 4px;

          &:hover {
            .news_info_right_item_last_count {
              opacity: 0.8;
            }

            .news_info_right_item_last_more {
              font-weight: bold;
            }

            .el-icon-d-arrow-right {
              font-weight: bold;
            }
          }

          .news_info_right_item_last_count {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 50px;
            font-weight: 500;
            color: #ffffff;
          }

          .news_info_right_item_last_more {
            position: absolute;
            bottom: 8px;
            left: 11px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;

            .el-icon-d-arrow-right {
              margin-left: 5px;
            }
          }
        }

        &:hover {
          transition: all 0.6s;
          cursor: pointer;

          img {
            transform: scale(1.05);
          }
        }

        .news_info_right_item {
          width: 220px;
          height: 160px;
          position: relative;
          background: rgba(0, 0, 0, 0.5);
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          img {
            width: 220px;
            height: 160px;
            object-fit: cover;
            position: absolute;
            z-index: 0;
            transition: all 0.3s;
          }

          .news_info_right_item_date {
            margin-left: 11px;
            margin-top: 15px;
            font-size: 14px;
            z-index: 11;
            font-weight: 400;
            color: #ffffff;
          }

          .news_info_right_item_title {
            width: 198px;
            height: 44px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            line-height: 22px;
            z-index: 11;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-left: 11px;
            margin-bottom: 14px;
          }
        }
      }
    }
  }
}


.culturalhistory {
  background: #f8f8f8;
  //min-height: 1654px;
  padding-bottom: 30px;
}

.bannerbg {
  position: relative;
  height: 339px;
  overflow: hidden;

  .bannerbg_pic {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 339px;
    object-fit: cover;
    width: 100%;
    display: block;
  }

  .bannerbg_desc {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    margin-top: 76px;
    padding-left: 40px;
    box-sizing: border-box;

    .bannerbg_desc_title {
      height: 70px;
      font-size: 50px;
      font-weight: 600;
      text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
      color: #ffffff;
      line-height: 70px;
    }

    .bannerbg_desc_entitle {
      height: 42px;
      font-size: 22px;
      // font-weight: 600;
      text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
      color: #ffffff;
      line-height: 42px;
    }
  }

  .banner_videoplay_icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    width: 120px;
    height: 120px;
    object-fit: cover;

    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }

  video {
    height: 100%;
    width: 100%;
    object-fit: contain;
    // position: relative;
    // z-index: 0;
  }
}

.contactus_content {
  width: 1200px;
  min-height: 803px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 47px 103px 73px 36px;
  margin: 0 auto;

  .contactus_content_up {
    box-sizing: border-box;
    min-height: 558px;
  }

  .contactus_content_but {
    width: 260px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: linear-gradient(124deg, #fec835 0%, #ffad19 100%);
    border-radius: 77px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;

    &:hover {
      opacity: 0.89;
      cursor: pointer;
    }
  }
}

.tradeelite {
  //min-height: 1161px;
  background: #f8f8f8;
  overflow: hidden;
  padding-bottom: 30px;

  .header_screen {
    //height: 132px;
    //background: #ffffff;
    //box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 13px;
    padding: 0 15px;
    box-sizing: border-box;

    .header_screen_item {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      cursor: default;

      .header_screen_item_title {
        width: 30px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-right: 41px;
      }

      .header_screen_item_els {
        flex: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .header_screen_item_el {
          height: 36px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 36px;
          //margin-right: 47px;
          //   margin-bottom: 23px;
          margin: 0 20px 10px 0;

          &:hover {
            cursor: pointer;
            color: #3B8DE3;
          }
        }

        .header_screen_item_el_active {
          //color: #f56057;
          font-weight: 500;
          padding: 0 10px;
          background: linear-gradient(130deg, #6BADF2 0%, #3B8DE3 100%);
          border-radius: 18px;
          color: #fff;
        }
      }
    }
  }

  .star_list {
    padding-top: 8px;
    box-sizing: border-box;
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // justify-content: space-between;
    font-size: 0;

    .star_list_item_wrap {
      display: inline-block;
      margin-right: 30px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .star_list_item {
        // flex:25%;
        display: flex;
        flex-direction: row;
        width: 380px;
        height: 140px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 16px;
        margin-top: 47px;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.03);
          cursor: pointer;
        }

        .star_list_item_pic {
          width: 119px;
          height: 146px;
          position: relative;
          margin: 0 24px 0 8px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: -15px;
            left: 0;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            overflow: hidden;
            background: pink;
          }
        }

        .star_list_item_right {
          display: flex;
          flex-direction: column;
          flex: 1;
          box-sizing: border-box;

          .star_list_item_right_name {
            max-width: 100%;
            height: 32px;
            font-size: 22px;
            font-weight: 500;
            color: #000000;
            line-height: 32px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 16px;
          }

          .star_list_item_right_des {
            max-width: 100%;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #444444;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 13px 0 7px 0;
          }

          .star_list_item_right_star {
            width: 88px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: linear-gradient(133deg, #fd9d00 0%, #fa6400 100%);
            border-radius: 10px 0px 10px 10px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// jingwai.vue?a3c0def8